
export class Command {
    async execute () {
        throw 'Function requires implementation'
    }

    async unExecute () {
        throw 'Function requires implementation'
    }

    get hasChanges () {
        throw 'Function requires implementation'
    }
}
